(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (root && typeof root === 'object') {
    root.ToeeHubRingPicker = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var LABELS = {
    od: 'Wheel center bore',
    id: 'Vehicle hub',
    material: 'Material'
  };

  function unavailableMessage() {
    return 'Fitment is temporarily unavailable';
  }

  function idsForOd(matrix, od) {
    var src = matrix || {};
    var idsByOd = src.idsByOd || {};
    var ids = idsByOd && od && idsByOd[od];
    return Array.isArray(ids) ? ids.slice() : [];
  }

  function materialsFor(matrix, od, id) {
    var src = matrix || {};
    var skus = src.skus || [];
    if (!Array.isArray(skus) || !od || !id) return [];
    var out = [];
    for (var i = 0; i < skus.length; i++) {
      var row = skus[i];
      if (!row) continue;
      if (row.od === od && row.id === id) out.push(row);
    }
    return out;
  }

  function canAddToCart(hiddenId) {
    return typeof hiddenId === 'string' && /^\d+$/.test(hiddenId);
  }

  function prefillOd(matrix, queryOd) {
    if (!queryOd) return { od: null, unavailable: false };
    var src = matrix || {};
    var ods = src.ods || [];
    for (var i = 0; i < ods.length; i++) {
      if (ods[i] === queryOd) return { od: queryOd, unavailable: false };
    }
    // Same millimetres written differently ("73" for the catalog's "73.0"): select the catalog's own string.
    for (var j = 0; j < ods.length; j++) {
      if (sameMm(ods[j], queryOd)) return { od: ods[j], unavailable: false };
    }
    return { od: null, unavailable: true };
  }

  function sameMm(a, b) {
    var x = String(a).trim();
    var y = String(b).trim();
    if (x === y) return true;
    var plain = /^\d+(\.\d+)?$/;
    return plain.test(x) && plain.test(y) && Number(x) === Number(y);
  }

  /** The inner diameter among this outer diameter's ids that equals ?hub= (as numbers: 67.10 is 67.1), else null. */
  function prefillId(matrix, od, queryHub) {
    if (!od || !queryHub) return null;
    var ids = idsForOd(matrix, od);
    for (var i = 0; i < ids.length; i++) {
      if (sameMm(ids[i], queryHub)) return ids[i];
    }
    return null;
  }

  function unknownOdMessage() {
    return 'This outer diameter is not in stock.';
  }

  function guestMustOmitPrice(sku, isGuest) {
    return !!isGuest;
  }

  function displayPrice(sku, isGuest) {
    if (isGuest) return null;
    return sku && sku.price != null ? sku.price : null;
  }

  function cleanSubpath(proxySubpath) {
    var raw = String(proxySubpath || 'paymentstatussync').trim();
    return raw || 'paymentstatussync';
  }

  function isCatalogOk(responseLike, json) {
    if (!responseLike || !responseLike.ok) return false;
    if (json && json.success === false) return false;
    if (json && json.truncated === true) return false;
    return true;
  }

  function catalogUrl(proxySubpath, productId) {
    var sub = cleanSubpath(proxySubpath);
    return '/apps/' + sub + '/fitment/hub-rings?product_id=' + encodeURIComponent(String(productId));
  }

  function resolveUrl(proxySubpath, productId, od, id, material) {
    var sub = cleanSubpath(proxySubpath);
    var qs =
      'product_id=' + encodeURIComponent(String(productId)) +
      '&od=' + encodeURIComponent(String(od || '')) +
      '&id=' + encodeURIComponent(String(id || '')) +
      '&material=' + encodeURIComponent(String(material || ''));
    return '/apps/' + sub + '/fitment/hub-ring?' + qs;
  }

  function applyResolvedId(inputEl, variantId) {
    if (!inputEl) return;
    var val = variantId ? String(variantId) : '';

    if (typeof inputEl.value !== 'undefined') inputEl.value = val;
    if (!val) {
      if (typeof inputEl.removeAttribute === 'function') inputEl.removeAttribute('name');
      else inputEl.name = '';
      return;
    }
    if (typeof inputEl.setAttribute === 'function') inputEl.setAttribute('name', 'id');
    else inputEl.name = 'id';
  }

  function variantChangeDetail(variantId) {
    return {
      variant: { id: Number(variantId), available: true },
      isProduct: function () { return false; }
    };
  }

  function variantJsUrl(variantId) {
    var id = String(variantId || '').trim();
    if (!/^\d+$/.test(id)) return '';
    return '/variants/' + id + '.js';
  }

  function formatMoneyCents(cents, formatMoney) {
    var html;
    if (typeof formatMoney === 'function') html = formatMoney(cents);
    else if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var fmt = typeof theme !== 'undefined' && theme.moneyFormat ? theme.moneyFormat : undefined;
      html = fmt ? Shopify.formatMoney(cents, fmt) : Shopify.formatMoney(cents);
    } else {
      var n = Number(cents);
      html = isFinite(n) ? '$' + (n / 100).toFixed(2) : '';
    }
    return String(html == null ? '' : html).replace(/<[^>]+>/g, '').trim();
  }

  function priceViewFromVariantJs(variant) {
    if (!variant || typeof variant !== 'object') return null;
    var price = Number(variant.price);
    if (!isFinite(price) || price <= 0) return null;
    var compare = variant.compare_at_price == null || variant.compare_at_price === ''
      ? 0
      : Number(variant.compare_at_price);
    if (!isFinite(compare)) compare = 0;
    return {
      displayCents: price,
      compareCents: compare,
      savingsCents: compare > price ? compare - price : 0,
      msrpCents: price * 2
    };
  }

  function setNodeMoney(node, html) {
    if (!node) return;
    var locked = node.querySelector && node.querySelector('[hidewlm]');
    var target = locked || node;
    target.textContent = html;
    target.innerHTML = html;
  }

  function applyPdpPrice(root, view, formatMoney) {
    if (!root || !view || typeof root.querySelector !== 'function') return;
    var money = function (cents) { return formatMoneyCents(cents, formatMoney); };
    setNodeMoney(root.querySelector('[data-variant-price]'), money(view.displayCents));

    var compareEl = root.querySelector('[data-variant-compare-at-price]');
    var savingsEl = root.querySelector('[data-savings]');
    var savingsTotalEl = root.querySelector('[data-savings-total]');
    if (view.compareCents && view.compareCents > view.displayCents) {
      if (compareEl) {
        if (compareEl.classList && compareEl.classList.remove) compareEl.classList.remove('hidden');
        compareEl.innerHTML = money(view.compareCents);
      }
      if (savingsEl) {
        if (savingsEl.classList && savingsEl.classList.remove) savingsEl.classList.remove('hidden');
        if (typeof savingsEl.removeAttribute === 'function') savingsEl.removeAttribute('hidden');
      }
      if (savingsTotalEl) {
        savingsTotalEl.innerHTML = money(view.savingsCents).replace(/((\,00)|(\.00))$/g, '');
      }
    } else {
      if (compareEl) {
        if (compareEl.classList && compareEl.classList.add) compareEl.classList.add('hidden');
        compareEl.innerHTML = '';
      }
      if (savingsEl) {
        if (savingsEl.classList && savingsEl.classList.add) savingsEl.classList.add('hidden');
        if (typeof savingsEl.setAttribute === 'function') savingsEl.setAttribute('hidden', '');
      }
      if (savingsTotalEl) savingsTotalEl.innerHTML = '';
    }

    var msrpEl = root.querySelector('.bmw-msrp-meta__value');
    if (msrpEl) msrpEl.textContent = money(view.msrpCents);
  }

  function refreshPdpPrice(container, variantId, formatMoney) {
    var url = variantJsUrl(variantId);
    if (!url || typeof fetch !== 'function') return Promise.resolve();
    var root = container && typeof container.closest === 'function'
      ? container.closest('form') || container
      : container;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('variant js not ok');
        return r.json();
      })
      .then(function (variant) {
        applyPdpPrice(root, priceViewFromVariantJs(variant), formatMoney);
      })
      .catch(function () {});
  }

  function getQueryParam(name) {
    if (typeof window === 'undefined' || !window.location) return '';
    var params = new URLSearchParams(window.location.search || '');
    return params.get(name) || '';
  }

  function clearSelect(selectEl, placeholder) {
    if (!selectEl) return;
    selectEl.innerHTML = '';
    var opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder || '--';
    selectEl.appendChild(opt);
  }

  function fillSelect(selectEl, values, placeholder) {
    clearSelect(selectEl, placeholder);
    var list = values || [];
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      var opt = document.createElement('option');
      opt.value = String(v);
      opt.textContent = String(v);
      selectEl.appendChild(opt);
    }
    selectEl.disabled = list.length === 0;
  }

  function fillMaterialSelect(selectEl, materials) {
    clearSelect(selectEl, '--');
    var list = materials || [];
    for (var i = 0; i < list.length; i++) {
      var row = list[i] || {};
      var opt = document.createElement('option');
      opt.value = String(row.material || '');
      opt.textContent = String(row.material || '');
      if (row.available === false) opt.disabled = true;
      opt.setAttribute('data-variant-id', String(row.variantId || ''));
      selectEl.appendChild(opt);
    }
    selectEl.disabled = list.length === 0;
  }

  function setUnavailable(el, messageEl, text) {
    if (messageEl) {
      messageEl.textContent = text;
      messageEl.hidden = false;
    }
    if (el) el.setAttribute('data-hub-ring-unavailable', 'true');
  }

  function clearUnavailable(container, messageEl) {
    if (messageEl) messageEl.hidden = true;

    if (!container) return;
    if (typeof container.removeAttribute === 'function') {
      container.removeAttribute('data-hub-ring-unavailable');
      return;
    }
    if (container.attributes && typeof container.attributes === 'object') {
      delete container.attributes['data-hub-ring-unavailable'];
    }
  }

  function setSubmitDisabled(container, disabled) {
    if (!container || typeof container.closest !== 'function') return;
    var form = container.closest('form');
    if (!form) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = !!disabled;
  }

  function dispatchVariantChanged(variantId) {
    try {
      var detail = variantChangeDetail(variantId);
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('product-variant-switch', { detail: detail }));
      }
      if (typeof document !== 'undefined' && document.dispatchEvent) {
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: detail }));
      }
    } catch (e) {}
  }

  function resolveVariantId(proxySubpath, productId, od, id, material, hiddenInput, container) {
    // IMPORTANT: do not write name="id" or dispatch variant events until resolve returns.
    return fetch(resolveUrl(proxySubpath, productId, od, id, material), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('resolve not ok');
        return r.json();
      })
      .then(function (json) {
        var vid = json && json.variantId;
        if (!canAddToCart(String(vid || ''))) throw new Error('missing variantId');
        applyResolvedId(hiddenInput, String(vid));
        setSubmitDisabled(container, !canAddToCart(String(vid)));
        dispatchVariantChanged(String(vid));
        refreshPdpPrice(container, String(vid));
        return String(vid);
      });
  }

  function initOne(container) {
    if (!container || container.getAttribute('data-hub-ring-init') === '1') return;
    container.setAttribute('data-hub-ring-init', '1');

    var productId = container.getAttribute('data-product-id') || '';
    var proxySubpath = container.getAttribute('data-app-proxy-subpath') || 'paymentstatussync';
    var isGuest = container.getAttribute('data-guest') === 'true';
    // guestMustOmitPrice/displayPrice are exported; UI intentionally does not render API prices.
    if (isGuest) displayPrice({}, true);

    var odSel = container.querySelector('[data-hub-ring-od]');
    var idSel = container.querySelector('[data-hub-ring-id]');
    var matSel = container.querySelector('[data-hub-ring-material]');
    var hiddenInput = container.querySelector('[data-hub-ring-variant-id]');
    var msg = container.querySelector('[data-hub-ring-message]');

    setSubmitDisabled(container, true);
    clearSelect(odSel, '--');
    clearSelect(idSel, '--');
    clearSelect(matSel, '--');
    if (odSel) odSel.disabled = true;
    if (idSel) idSel.disabled = true;
    if (matSel) matSel.disabled = true;

    var matrix = null;
    var queryOd = getQueryParam('od');
    var queryHub = getQueryParam('hub');

    function resetResolved() {
      applyResolvedId(hiddenInput, '');
      setSubmitDisabled(container, true);
    }

    function onOdChanged() {
      resetResolved();
      clearUnavailable(container, msg);
      var od = odSel ? odSel.value : '';
      fillSelect(idSel, idsForOd(matrix, od), '--');
      clearSelect(matSel, '--');
      if (matSel) matSel.disabled = true;
    }

    function onIdChanged() {
      resetResolved();
      var od = odSel ? odSel.value : '';
      var id = idSel ? idSel.value : '';
      fillMaterialSelect(matSel, materialsFor(matrix, od, id));
    }

    function onMaterialChanged() {
      resetResolved();
      var od = odSel ? odSel.value : '';
      var id = idSel ? idSel.value : '';
      var material = matSel ? matSel.value : '';
      if (!od || !id || !material) return;
      resolveVariantId(proxySubpath, productId, od, id, material, hiddenInput, container)
        .then(function (variantId) {
          clearUnavailable(container, msg);
          return variantId;
        })
        .catch(function () {
          setUnavailable(container, msg, unavailableMessage());
          resetResolved();
        });
    }

    if (odSel) odSel.addEventListener('change', onOdChanged);
    if (idSel) idSel.addEventListener('change', onIdChanged);
    if (matSel) matSel.addEventListener('change', onMaterialChanged);

    fetch(catalogUrl(proxySubpath, productId), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r) throw new Error('catalog missing response');
        return r.json().then(function (json) {
          if (!isCatalogOk(r, json)) throw new Error('catalog not ok');
          return json;
        });
      })
      .then(function (json) {
        clearUnavailable(container, msg);
        matrix = json || {};
        var ods = matrix.ods || [];
        fillSelect(odSel, ods, '--');

        var pre = prefillOd(matrix, queryOd);
        if (pre.unavailable) {
          setUnavailable(container, msg, unknownOdMessage());
          if (idSel) idSel.disabled = true;
          if (matSel) matSel.disabled = true;
        } else if (pre.od) {
          odSel.value = pre.od;
          onOdChanged();
          var hubId = prefillId(matrix, pre.od, queryHub);
          if (hubId && idSel) {
            idSel.value = hubId;
            onIdChanged();
          }
        } else {
          if (idSel) idSel.disabled = true;
          if (matSel) matSel.disabled = true;
        }
        if (odSel) odSel.disabled = false;
      })
      .catch(function () {
        setUnavailable(container, msg, unavailableMessage());
      });
  }

  function init() {
    if (typeof document === 'undefined') return;
    var nodes = document.querySelectorAll('[data-hub-ring-picker]');
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  return {
    LABELS: LABELS,
    idsForOd: idsForOd,
    materialsFor: materialsFor,
    canAddToCart: canAddToCart,
    prefillOd: prefillOd,
    prefillId: prefillId,
    guestMustOmitPrice: guestMustOmitPrice,
    displayPrice: displayPrice,
    unavailableMessage: unavailableMessage,
    unknownOdMessage: unknownOdMessage,
    isCatalogOk: isCatalogOk,
    catalogUrl: catalogUrl,
    resolveUrl: resolveUrl,
    resolveVariantId: resolveVariantId,
    applyResolvedId: applyResolvedId,
    variantChangeDetail: variantChangeDetail,
    variantJsUrl: variantJsUrl,
    priceViewFromVariantJs: priceViewFromVariantJs,
    applyPdpPrice: applyPdpPrice,
    refreshPdpPrice: refreshPdpPrice,
    clearUnavailable: clearUnavailable,
    init: init
  };
});

